
import React from 'react';

interface BigButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger' | 'success';
  className?: string;
  type?: 'button' | 'submit';
}

export const BigButton: React.FC<BigButtonProps> = ({ 
  onClick, 
  children, 
  variant = 'primary', 
  className = '',
  type = 'button'
}) => {
  const baseStyles = "text-2xl font-bold py-6 px-8 rounded-2xl shadow-lg active:scale-95 transition-transform duration-100 flex items-center justify-center gap-2 w-full";
  
  const variants = {
    primary: "bg-blue-600 text-white hover:bg-blue-700",
    secondary: "bg-gray-200 text-gray-800 hover:bg-gray-300 border-2 border-gray-400",
    danger: "bg-red-600 text-white hover:bg-red-700",
    success: "bg-green-600 text-white hover:bg-green-700",
  };

  return (
    <button 
      type={type}
      onClick={onClick} 
      className={`${baseStyles} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};
